import useApi from "./useApiRequest";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";

export const ReimprimirEtiquetas = ()  => {
    const api = useApi();
    const { givenName } = useSelector((state) => state.auth.user);

    const mutate = async (params) => {
        params.usuario = givenName;
        const data  = await api.post(`/administracion-inventario/reimprimir/etiquetas`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
      reimprimirEtiquetasMutation: mutation.mutate,
    };
}